import React from "react";
import TextField from "@mui/material/TextField";

type Props = {
    setPublicationYear: React.Dispatch<React.SetStateAction<string | undefined>>
    publicationYear?: string
}

function NewPublicationYear({setPublicationYear,publicationYear}: Props) {
    return (
        <TextField id="standard-basic" label="Veröffentlichungsjahr" variant="standard"
                   value={publicationYear || ""} type="number"
                   onChange={(event: React.ChangeEvent<HTMLInputElement>) => setPublicationYear(event.target.value)}/>
    );
}

export default NewPublicationYear;